// Added by Sejune Oh on 2020-02-19
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    Select as MaterialSelect,
    SelectProps as MaterialSelectProps
} from '@material-ui/core'

// Common props
interface SelectBaseProps { }
export type SelectProps = Partial<MaterialSelectProps> & SelectBaseProps

export const Select: FC<SelectProps> = ({ ...props }) => {
    return <MaterialSelect  {...props} />
}
